import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ChangeEmailInitiate = gql`
  mutation ChangeEmailInitiate($input: ChangeEmailInitiateInput!) {
    changeEmailInitiate(input: $input) {
      ... on ChangeEmailInitiateSuccess {
        success
        customerInfo {
          phone
        }
        otpExpirationTime
        __typename
      }

      ... on ChangeEmailTooManyAttempts {
        ...error
        __typename
      }

      ... on ChangeEmailError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;
export default ChangeEmailInitiate;
